'use client';
import { CaptchaRequestMessage, isCaptchaValidationError } from '@eliadmin/core/src/components/providers/captcha-form-message';
import { useState as useCaptchaRequestErrorState } from 'react';

import { useSystemLabels } from '@eliadmin/core/src/hooks/use-system-labels';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { Heading } from '@eliadmin/core/src/components/ui/heading';
import { Input } from '@eliadmin/core/src/components/ui/input';
import { Paragraph } from '@eliadmin/core/src/components/ui/paragraph';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { env } from '@eliadmin/core/src/env';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useGlobalStore } from '@eliadmin/core/src/stores/global-store';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import Link from 'next/link';
import React from 'react';

export function Newsletter() {
const [captchaRequestError, setCaptchaRequestError] = useCaptchaRequestErrorState<unknown>(null);
  const emailId = React.useId();
  const systemLabels = useSystemLabels();
  const { t } = useTranslations();
  const generalLayout = useGlobalStore(s => s.generalLayout);

  // state
  const [email, setEmail] = React.useState('');
  const checked = true;
  const [isSubscribed, setIsSubscribed] = React.useState(false);
  const [isAlreadySubscribed, setIsAlreadySubscribed] = React.useState(false);

  const [isPending, setPending] = React.useState(false);
  const submitting = React.useRef(false);

  const locale = useLocaleStore(s => s.currentLocale);

  async function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();
    if (!checked || isSubscribed || !email || submitting.current) return;
    submitting.current = true;
    setPending(true);
    setIsAlreadySubscribed(false);
    try {
setCaptchaRequestError(null);
      const { newsletterSubscribe } =
        await import('@eliadmin/core/src/api/newsletter/newsletter-api');
      await newsletterSubscribe({
        locale,
        body: {
          email,
          gdpr: checked,
          return_url: new URL(ROUTES.NEWSLETTER_CONFIRM(), env.NEXT_PUBLIC_APP_URL).toString(),
        },
      });
      setIsSubscribed(true);
      // Analytics failure must not turn a successful subscription into a failed form.
      void import('@eliadmin/core/src/components/analytics/analytics-helpers')
        .then(({ trackFormSubmitSuccess }) =>
          trackFormSubmitSuccess({
            form_id: 'newsletter',
            form_name: 'newsletter_form',
            form_destination: window.location.href,
            form_length: 2,
            send_to: generalLayout.marketing?.gtm_id,
          }),
        )
        .catch(() => undefined);
    } catch (captchaRequestError) { setCaptchaRequestError(captchaRequestError); if (isCaptchaValidationError(captchaRequestError)) { setIsAlreadySubscribed(false); return; }
      setIsAlreadySubscribed(true);
     } finally {
      submitting.current = false;
      setPending(false);
    }
  }

  return (
    <div className="flex w-full flex-col items-start justify-start gap-6 md:max-w-[384px]">
      <div className="flex w-full flex-col items-start justify-start gap-3">
        <Heading title="Newsletter" tag="h2" visualTag="h4" color="white" />
        <Paragraph color="white" size="sm" className="w-full">
          {t('text2344')}
        </Paragraph>
      </div>
      <form
        onSubmit={handleSubmit}
        className="flex w-full flex-col items-start justify-start gap-3"
      >
<CaptchaRequestMessage error={captchaRequestError} />
        <Input
          aria-label={systemLabels('email')}
          id={emailId}
          type="email"
          autoComplete="email"
          required
          name="email"
          placeholder={t('text3464')}
          onChange={e => setEmail(e.target.value)}
          className={{
            wrapper: cn(
              'h-[50px] border-none bg-white',
              'ea-homepage-newsletter__form-item-email-input',
            ),
            main: cn('border-none'),
          }}
          after={
            <Button
              type="submit"
              className={cn(
                'h-[42px] rounded-[12px] bg-primary sm:h-[42px]',
                'ea-homepage-newsletter__form-item-email-submit-button',
              )}
              disabled={email.length === 0 || !checked || isSubscribed || isPending}
              isLoading={isPending}
            >
              {t('text182')}
            </Button>
          }
        />
        <span role="status" aria-live="polite" className="text-sm text-white">
          {isSubscribed ? t('text3139') : isAlreadySubscribed ? t('text234') : null}
        </span>
        <Paragraph size="xs" color="white">
          {t('text3264')}&nbsp;
          <Link
            target="_blank"
            href={'/ochrana-osobnych-udajov'}
            className="font-normal text-primary"
          >
            {t('text614')}
          </Link>
          &nbsp;
          {t('text3389')}
        </Paragraph>
      </form>
    </div>
  );
}

// <section id="newsletters" className={cn('p-2 sm:p-12', 'ea-homepage-newsletter')}>
//   <form
//     className={cn('grid grid-cols-12 gap-6 py-2', 'ea-homepage-newsletter__form')}
//     onSubmit={handleSubmit}
//   >
//     <div
//       className={cn(
//         'col-span-12 flex flex-row items-center justify-start space-x-4 md:col-span-7 md:pr-7',
//         'ea-homepage-newsletter__form-icon-email',
//       )}
//     >
//       <div className={cn('rounded-full bg-accent p-4')}>
//         <LuMail
//           className={cn(
//             'h-10 w-10 stroke-primary',
//             'ea-homepage-newsletter__form-icon-email-icon',
//           )}
//         />
//       </div>
//       <div className={cn('flex flex-col gap-2', 'ea-homepage-newsletter__form-title')}>
//         <h4
//           className={cn(
//             'max-w-sm text-2xl font-bold',
//             'ea-homepage-newsletter__form-title-main',
//           )}
//         >
//           {t('text610')}
//         </h4>
//         <p
//           className={cn(
//             'text-sm text-muted-foreground',
//             'ea-homepage-newsletter__form-title-sub',
//           )}
//         >
//           {t('text609')}
//         </p>
//       </div>
//     </div>
//     <div
//       className={cn(
//         'col-span-12 flex flex-col justify-center space-y-3 md:col-span-5',
//         'ea-homepage-newsletter__form-item-email',
//       )}
//     >
//       <div className={cn('flex h-10 flex-row items-center')}>
//         <Input
//           id="newsletter-email"
//           type="email"
//           name="email"
//           placeholder={t('text183')}
//           onChange={e => setEmail(e.target.value)}
//           className={{
//             wrapper: cn(
//               'border-none bg-input pr-1 text-muted-foreground',
//               'ea-homepage-newsletter__form-item-email-input',
//             ),
//           }}
//           after={
//             <Button
//               type="submit"
//               className={cn(
//                 'h-10 rounded-[12px] border-none bg-primary px-2 text-primary-foreground',
//                 'ea-homepage-newsletter__form-item-email-submit-button',
//               )}
//               disabled={email.length === 0 || !checked || isSubscribed}
//               isLoading={subscribeMutation.isPending}
//             >
//               {t('text182')}
//             </Button>
//           }
//         />
//       </div>
//       {isSubscribed && !isAlreadySubscribed && (
//         <span className={cn('font-semibold text-success')}>{t('text3139')}</span>
//       )}
//       {isAlreadySubscribed && (
//         <span className={cn('text-error font-semibold')}>{t('text234')}</span>
//       )}
//       <div
//         className={cn(
//           'flex flex-row items-start space-x-2',
//           'ea-homepage-newsletter__form-item-gdpr',
//         )}
//       >
//         <Checkbox
//           checked={checked}
//           onCheckedChange={() => setChecked(!checked)}
//           id="newsletter-gdpr"
//           aria-label={t('text264') + ' ' + t('text265') + ' ' + t('text436')}
//           className={cn('', 'ea-homepage-newsletter__form-item-gdpr-checkbox')}
//           required
//         />
//         <Label
//           htmlFor="newsletter-gdpr"
//           className={cn('pt-[3px]', 'ea-homepage-newsletter__form-item-gdpr-checkbox-label')}
//         >
//           <GdprTextNewsletter locale={locale} />
//         </Label>
//       </div>
//     </div>
//   </form>
// </section>
